import React from 'react'
import Header from '../components/Header'
import HistoryTable from '../components/HistoryTable'

function History() {
    return (
        <div>
            <Header />
            <HistoryTable />
        </div>
    )
}

export default History
